import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ setMinimumQtyError: boolean }>;

export const DispatchSetMinimumQtyError: HandlerType = props => {
    props.dispatch({
        type: "Custom/Product/DispatchMinimumQtyError",
        param: props.parameter.setMinimumQtyError,
    });
};

export const chain = [DispatchSetMinimumQtyError];

const setMinimumQtyError = createHandlerChainRunner(chain, "setMinimumQtyError");
export default setMinimumQtyError;
